// components/weather/HourlyChart.jsx
import React from 'react';
import { msToKnots, formatNum } from './utils';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  CartesianGrid,
} from 'recharts';

// Couleurs par défaut (modifiables via la prop `colors`)
const DEFAULT_COLORS = {
  wave: '#1f77b4',   // Vagues (m) - bleu
  swell: '#2ca02c',  // Houle (m) - vert
  wind: '#d62728',   // Vent (nds) - rouge
  windMs: '#9467bd', // Vent (m/s) - violet
};

/**
 * HourlyChart
 * - Courbes : Vagues (m), Houle (m), Vent (nds) + option Vent (m/s)
 * - Personnalisation des couleurs via la prop `colors`
 */
export default function HourlyChart({ rows, showMS = false, colors = {} }) {
  if (!rows?.length) return null;

  const palette = { ...DEFAULT_COLORS, ...colors };

  const data = rows.map((r) => ({
    time: r.localTime,
    Vague_m: r.waveHeight_m,
    Houle_m: r.swellHeight_m,
    Vent_nds: msToKnots(r.windSpeed_ms),
    Vent_ms: r.windSpeed_ms,
  }));

  return (
    <div style={{ width: '100%', height: 320, marginBottom: 20 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="time" tick={{ fontSize: 12 }} />
          <YAxis yAxisId="left" tick={{ fontSize: 12 }} />
          <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 12 }} />
          <Tooltip formatter={(v, name) => [formatNum(v), name]} />
          <Legend iconType="circle" />

          <Line
            yAxisId="left"
            type="monotone"
            dataKey="Vague_m"
            name="Vagues (m)"
            dot={false}
            strokeWidth={2}
            stroke={palette.wave}
          />
          <Line
            yAxisId="left"
            type="monotone"
            dataKey="Houle_m"
            name="Houle (m)"
            dot={false}
            strokeWidth={2}
            stroke={palette.swell}
            strokeDasharray="4 2"
          />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="Vent_nds"
            name="Vent (nds)"
            dot={false}
            strokeWidth={2}
            stroke={palette.wind}
          />
          {showMS && (
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="Vent_ms"
              name="Vent (m/s)"
              dot={false}
              strokeWidth={2}
              stroke={palette.windMs}
            />
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
